import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  text-align: left;
`;

export const StyledFaIcon = styled(FontAwesomeIcon)`
  border: ${props => props.theme.border};
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.boxShadow};
`;

export const Content = styled.div`
  display: inline-flex;
  align-items: center;

  ${Media.lg`
    display: none;
    grid-template-columns: 1fr;
  `}

  ${props =>
    props.toggle &&
    css`
      ${Media.lg`
        display: grid;
      `}
    `}
`;

export const ItemExternal = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: auto;
  height: auto;
  padding: 5px;
  margin: 2px;
  color: ${props => (props.color ? props.color : props.theme.color)};
  transition: 0.2s all;
  cursor: pointer;

  ${Media.lg`
    display: grid;
    grid-template-columns: 44px 1fr;
    grid-gap: 10px;
    padding: ${props => props.theme.padding.lg};
    margin: 0;
    border-top: 1px solid ${props => props.theme.border};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}

  &:last-of-type {
    ${Media.lg`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }
`;

export const Item = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: auto;
  height: auto;
  padding: 5px;
  margin: 2px;
  color: ${props => (props.color ? props.color : props.theme.color)};
  transition: 0.2s all;
  cursor: pointer;

  ${Media.lg`
    display: grid;
    grid-template-columns: 44px 1fr;
    grid-gap: 10px;
    padding: ${props => props.theme.padding.lg};
    margin: 0;
    border-top: 1px solid ${props => props.theme.border};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}

  &:last-of-type {
    ${Media.lg`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }
`;

export const Title = styled.span`
  display: block;
  width: 100%;
  padding: 5px;
  margin: 2px;
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  text-align: center;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
    text-align: left;
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  ${Item}:hover &, ${ItemExternal}:hover &{
    color: ${props => props.theme.colorOnHover};
  }
`;

export const Icon = styled.i`
  margin: 2px;
  font-size: ${props => `${props.size}`};
`;
